module.exports = __webpack_public_path__ + "static/media/Index.fe7943f7.svg";